import {
  ChartBarIcon,
  TagIcon,
} from "@heroicons/react/24/outline";

type PlaceholderProps = {
  title: string;
  subtitle: string;
  Icon: typeof ChartBarIcon;
  hint?: string;
};

function Placeholder({ title, subtitle, Icon, hint }: PlaceholderProps) {
  return (
    <div className="px-5 py-8 md:px-10 md:py-10 max-w-5xl mx-auto animate-fade-in">
      <header className="mb-6">
        <h1 className="text-[28px] md:text-[34px] font-semibold tracking-tight">{title}</h1>
        <p className="text-[15px] text-ios-muted mt-1">{subtitle}</p>
      </header>
      <div className="ios-card p-10 text-center">
        <Icon className="w-12 h-12 mx-auto text-ios-subtle mb-3" />
        <p className="text-[15px] text-ios-muted">
          {hint ?? "Diese Ansicht kommt in den nächsten Tagen."}
        </p>
      </div>
    </div>
  );
}

export const AuswertungenPage = () => (
  <Placeholder
    title="Auswertungen"
    subtitle="Reports nach Kategorie, Zeitraum, Gruppe"
    Icon={ChartBarIcon}
    hint="Donut-Charts + Vorjahresvergleich. Wird in Tag 8 gebaut."
  />
);
export const TagsPage = () => (
  <Placeholder title="Tags" subtitle="Tags verwalten und Belege markieren" Icon={TagIcon} />
);
